import { findObjectPathsByValue } from 'src/components/pages/administration/product/logic/ObjectPaths'
import { getObjectWithStringPath } from 'src/helper/getObjectWithStringPath'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'

export const getWorkUnitByTokenRecursive = (work_units_nodes, token_work_unit) => {
    if (token_work_unit.length >= 1) {
      let path = findObjectPathsByValue(work_units_nodes, token_work_unit)
      if (path) {
        if (path.lastIndexOf('.') === path.length - (path.length - path.lastIndexOf('.'))) {
          let path_without_last_prop = path.substring(0, path.length - (path.length - path.lastIndexOf('.')))
          // example from '[0].children[0].children[0].children[0].value'
          // to 'path [0].children[0].children[0].children[0]'
          if (path_without_last_prop) {
            let work_unit_obj = getObjectWithStringPath(work_units_nodes, path_without_last_prop)
            return work_unit_obj
          }
        }
      }
    }
}


export const getWorkUnitByTokenService = async (token_work_unit) => {
    try {
      if (token_work_unit.length >= 1) {
        let params = { token: token_work_unit }
        let work_unit_found = await workUnitServices.getByParam(params)
        if (work_unit_found.length == 1) {
          return work_unit_found[0]
        }
      }
    } catch (error) {
      throw error
    }
}